export default __webpack_public_path__ + "static/media/logisticGray.04bb2045.svg";